export default __webpack_public_path__ + "static/media/conveyor-belt.abfca30c.png";